module.exports = __webpack_public_path__ + "img/libraryImage.png.01a24cff.webp";